import React, { useState, useContext } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { createSpecialization, getDepartmentList, updateSpecialization } from "../../../../actions/configuration";
import { toast } from "react-toastify";
import { LangCtx, PayLoadCtx } from "../../../../lib/context";
import InputField from "../../../../lib/ui/inputs/Input";
import { Button, FormControl, FormHelperText, TextareaAutosize } from "@material-ui/core";
import { validateCharecters, validateConfigCode } from "../../../../lib/validation";
import { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Loader from "../../../../lib/ui/loader/Loader";
import {API} from 'aws-amplify';

const CreateSpecialization = ({ indSpecData, handleClose, open, UpdSpeData,rowsPerPage,page }) => {
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);

    const [specData, setSpecData] = useState({
        specName: "",
        code: "",
        desc: "",
    });
    const [departs, setDeparts] = useState([]);
    const [value, setValue] = useState([]);

    const [formError, setFormError] = useState("");
    const [loading, setLoading] = useState(false);
    const handleChange = (e) => {
        e.persist();
        const id = e.target.id || e.target.name;
        setSpecData((prevState) => ({
            ...prevState,
            [id]: e.target.value,
        }));
    };

    const handleDepartmentsList = () => {
        setLoading(true);
        let id = payload?.consultRole === "clinic" ? payload?.userId : payload?.clinicId;
        let query=`?clinicId=${id}&type=all`
        if (rowsPerPage){
            query+=`&limit=${rowsPerPage}`
        }
        if(page){
            query+=`&skip=${page}`    
        }
        getDepartmentList(query)
            .then((res) => {
                if (res.status) {
                    setDeparts(res.data);
                    if (indSpecData?.departmentIds && indSpecData.departmentIds.length > 0) {
                        for (let each of res?.data) {
                            if (indSpecData.departmentIds.includes(each?._id)) {
                                setValue((pre) => [...pre, each]);
                                setLoading(false);
                            }
                        }
                    }
                    if (UpdSpeData?.departmentIds && UpdSpeData.departmentIds.length > 0) {
                        for (let each of res?.data) {
                            if (UpdSpeData.departmentIds.includes(each?._id)) {
                                setValue((pre) => [...pre, each]);
                                setLoading(false);
                            }
                        }
                    }
                } else {
                    setDeparts([]);
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(".............:", err);
                setDeparts([]);
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        handleDepartmentsList();
        setLoading(false);
    }, []);

    useEffect(() => {
        setSpecData({
            specName: indSpecData?.name ? indSpecData?.name : "",
            code: indSpecData?.code ? indSpecData?.code : "",
            desc: indSpecData?.description ? indSpecData?.description : "",
       });
    }, [indSpecData]);

    const handleSave = (e) => {
        e.preventDefault();
        const { specName, code, desc } = specData;
        let form_error = {};

        if (specData?.specName === "") {
            form_error["specName"] = l.pls_enter_name;
        } else if (specData?.specName !== "" && !validateCharecters(specData?.specName)) {
            form_error["specName"] = l.pls_enter_valid_name;
        }

        if (code !== "" && !validateConfigCode(code)) {
            form_error["code"] = l.pls_enter_valid_code;
        }

        if (value !== "" && value.length === 0) {
            form_error["depart"] = "Please Select atleast One department";
        }
        setFormError(form_error);
        console.log("fomr error", form_error);

        if (Object.keys(form_error).length <= 0) {
            if (!loading) {
                let body = {
                    name: specName,
                    code: code,
                    description: desc,
                    departmentIds: value.map((item) => item._id),
                };

                if (indSpecData) {
                    body["id"] = indSpecData?._id;
                    setLoading(true);
                    updateSpecialization(body)
                        .then((res) => {
                            if (res.status) {
                                toast.success(l.spec_edited, {
                                    position: toast.POSITION.TOP_RIGHT,
                                });
                                handleClose(true);
                            } else {
                                console.log("something went wrong");
                            }
                            setLoading(false);
                        })
                        .catch((err) => {
                            toast.error(err?.response?.data?.error, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                        });
                } else {
                    setLoading(true);
                    createSpecialization(body)
                        .then((res) => {
                            if (res.status) {
                                toast.success(l.spe_created, {
                                    position: toast.POSITION.TOP_RIGHT,
                                });
                                handleClose(true);
                            } else {
                                console.log("something went wrong");
                            }

                            setLoading(false);
                        })
                        .catch((err) => {
                            toast.error(err?.response?.data?.error, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            setLoading(false);
                        });
                }
            }
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm">
            {loading && <Loader />}
            <DialogTitle id="form-dialog-title">{indSpecData ? "Edit Specialization" : l.create_specialization}</DialogTitle>
            <DialogContent>
                <div className="flexCol">
                    <small className="inpLabel">
                        {l.specialization_name}
                        <span className="redTxt">*</span>:
                    </small>
                    <div className="inputRowFeild">
                        <FormControl fullWidth>
                            <InputField
                                placeholder=""
                                type="text"
                                id="specName"
                                name="specName"
                                maxLength={30}
                                value={specData?.specName}
                                error={formError && formError?.specName}
                                errorMsg={formError.specName}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </div>
                </div>
                <div className="flexCol">
                    <small className="inpLabel">Select Departments:</small>
                    <div className="inputRowFeild">
                        {/* {departs && departs.length > 0 && departs.map((item, ind)=>
                                  <div key={ind}>
                                      <input type='checkbox' checked={Boolean(selectedDeparts.includes(item?._id))} onClick={(e) => handleSelectDepts(item, ind)} value={item?.name} name={item?.name} for={item?.name} />
                                      <label htmlFor={item?.name}>{item?.name}</label>
                                  </div>      onChange={onChange} value={} name={}
                              )} */}
                        <Autocomplete
                            multiple
                            id="fixed-tags-demo"
                            value={value}
                            variant="outlined"
                            limitTags={3}
                            onChange={(event, newValue) => {
                                setValue([...newValue]);
                            }}
                            options={departs}
                            getOptionLabel={(option) => option?.name}
                            defaultValue={[]}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="Select Departments" variant="outlined" size="small" />
                            )}
                        />
                        <span id="component-error-text" className="inputErrorMsg">
                            {formError?.depart}
                        </span>
                    </div>
                </div>
                <small className="inpLabel">{l.specialization_code}</small>
                <div className="inputRowFeild">
                    <FormControl fullWidth>
                        <InputField
                            placeholder=""
                            id="code"
                            name="code"
                            type="text"
                            maxLength={6}
                            value={specData?.code}
                            error={formError && formError?.code}
                            errorMsg={formError.code}
                            onChange={handleChange}
                        />
                    </FormControl>
                </div>
                <div className="flexCol">
                    <small className="inpLabel">{l.desc}</small>
                    <div className="inputRowFeild">
                        <FormControl>
                            <TextareaAutosize
                                aria-label="empty textarea"
                                id="desc"
                                name="desc"
                                value={specData?.desc}
                                onChange={handleChange}
                                minRows={5}
                                maxLength={150}
                                placeholder={l.add_description}
                            />
                            <FormHelperText id="component-error-text" className="">
                                {formError?.desc}
                            </FormHelperText>
                        </FormControl>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {l.cancel}
                </Button>
                <Button variant="contained" color="primary" href="#contained-buttons" className="whiteTxt" onClick={handleSave}>
                    {indSpecData ? "Update" : l.add}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateSpecialization;
